export default __webpack_public_path__ + "static/media/Gauntlets of Indra.334a898c.jpg";